import React from 'react';
import { Helmet } from 'react-helmet';
import GooglePlayBadge from '../GooglePlayBadge/GooglePlayBadge';
import './AppPage.css';

const MediaPlayerAppPage = () => {
  return (
    <>
      <Helmet>
        <title>Media Player - Audio Video Mp3 | Nirmal Labs</title>
        <meta name="description" content="Download Media Player app for universal audio and video playback. 50K+ downloads, 4.1 rating. Support all formats including MP4, AVI, MKV, MP3. HD playback with equalizer." />
        <meta name="keywords" content="media player, video player, audio player, MP3 player, HD video, universal format, equalizer, subtitle support, playlist management" />
        <meta property="og:title" content="Media Player - Audio Video Mp3 | Nirmal Labs" />
        <meta property="og:description" content="Universal media player supporting all audio and video formats. HD playback with equalizer and subtitle support." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://nirmallabs.com/media-player" />
        <meta property="og:image" content="https://nirmallabs.com/images/media-player-app-screenshot.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Media Player - Audio Video Mp3 | Nirmal Labs" />
        <meta name="twitter:description" content="Universal media player supporting all audio and video formats. HD playback with equalizer and subtitle support." />
        <meta name="twitter:image" content="https://nirmallabs.com/images/media-player-app-screenshot.jpg" />
        <link rel="canonical" href="https://nirmallabs.com/media-player" />
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MobileApplication",
            "name": "Media Player - Audio Video Mp3",
            "description": "Universal media player supporting all audio and video formats with HD playback",
            "applicationCategory": "VideoPlayersAndEditorsApplication",
            "operatingSystem": "Android",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.1",
              "ratingCount": "642"
            }
          })}
        </script>
      </Helmet>

      <div className="app-page">
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <img 
                src="https://ik.imagekit.io/l9paoajth/app_logos/logo_media_player.webp?updatedAt=1759892173851&tr=w-120,h-120" 
                alt="Media Player App Icon" 
                className="app-icon"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/120x120/31B8D6/FFFFFF?text=M';
                }}
              />
              <h1>Media Player - Audio Video Mp3</h1>
              <p className="hero-description">
                Universal media player supporting all audio and video formats. High-definition playback 
                with equalizer, subtitle support, and playlist management. Perfect for all your media needs.
              </p>
              <div className="download-buttons">
                <GooglePlayBadge 
                  href="https://play.google.com/store/apps/details?id=com.nirmallabs.mediaplayer.musicplayer.videoplayer"
                  size="large"
                  ariaLabel="Download Media Player App from Google Play Store"
                />
              </div>
              <div className="app-stats">
                <span className="downloads">50K+ Downloads</span>
                <span className="rating">⭐ 4.1 Rating</span>
                <span className="category">Video Players & Editors</span>
              </div>
            </div>
          </div>
        </section>

        <section className="features-section">
          <div className="container">
            <h2>Key Features</h2>
            <div className="features-grid">
              <div className="feature-card">
                <h3>Universal Format Support</h3>
                <p>Play all popular video and audio formats effortlessly, including MP4, AVI, MKV, MP3, and more</p>
              </div>
              <div className="feature-card">
                <h3>High-Definition Playback</h3>
                <p>Enjoy your videos in stunning HD quality, supporting 4K/ultra HD video files with hardware acceleration</p>
              </div>
              <div className="feature-card">
                <h3>Equalizer & Audio Effects</h3>
                <p>Enhance your audio experience with built-in equalizer settings and audio effects for rich, immersive sound</p>
              </div>
              <div className="feature-card">
                <h3>Subtitle & Playlist Support</h3>
                <p>Easily add and manage subtitles, create and manage playlists, and enjoy background play functionality</p>
              </div>
            </div>
          </div>
        </section>

        <section className="screenshots-section">
          <div className="container">
            <h2>App Screenshots</h2>
            <div className="screenshots-carousel">
              <img src="/images/media-player-screenshot-1.jpg" alt="Media Player Main Interface" />
              <img src="/images/media-player-screenshot-2.jpg" alt="Media Player Video Playback" />
              <img src="/images/media-player-screenshot-3.jpg" alt="Media Player Audio Controls" />
            </div>
          </div>
        </section>

        <section className="description-section">
          <div className="container">
            <h2>About Media Player - Audio Video Mp3</h2>
            <p>
              Media Player All Media Player is a versatile and powerful multimedia application 
              designed to provide an unparalleled viewing and listening experience. Supporting a 
              wide array of audio and video formats, this app ensures seamless playback of your favorite media files.
            </p>
            <p>
              Features include universal format support, high-definition playback, customizable settings, 
              subtitle support, playlist management, background play, and equalizer with audio effects. 
              Perfect for users who want a comprehensive media solution for all their audio and video needs.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default MediaPlayerAppPage;
